import { useSettings } from '../context/SettingsContext';

function About() {
  const { theme } = useSettings();

  return (
    <div className="min-h-screen bg-puzzle-surface">
      <div className="max-w-2xl mx-auto px-4 py-16 text-center">
        {/* Logo */}
        <img
          src={theme === 'dark' ? '/images/logo_with_text_dark_mode.png' : '/images/logo_with_text.png'}
          alt="Puzzlists"
          className="h-32 mx-auto mb-6"
        />

        {/* Tagline */}
        <p className="text-xl text-puzzle-text-secondary mb-12">
          Daily jigsaw puzzles for everyone
        </p>

        {/* About content */}
        <div className="text-left space-y-6 text-puzzle-text">
          <p>
            Puzzlists brings you a fresh jigsaw puzzle every day.
            Challenge yourself, track your progress, and enjoy
            the satisfaction of completing beautiful puzzles.
          </p>
          <p>
            No downloads, no apps — just open your browser and play.
            Create an account to save your progress across devices,
            or play as a guest.
          </p>
        </div>

        {/* Founding date */}
        <p className="mt-16 text-puzzle-text-secondary text-sm">
          Est. January 2026
        </p>
      </div>
    </div>
  );
}

export default About;
